<template>
    <div class="mx-2 mx-lg-5">
        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("headers.gatehouseEdit") }}</h3>
            </div>
            <div class="card-body">
                <div class="p-4">
                    <GatehouseForm :gatehouse="gatehouse" ref="gatehouseForm" @submit="editGatehouse" />
                </div>
            </div>
        </div>
        <div class="my-4">
            <button class="btn btn-primary w-100 py-3 fw-bold fs-5 text-white" @click="submitForm">{{ $t("utils.saveChanges") }}</button>
        </div>
    </div>
</template>

<script>
import GatehouseForm from '@/components/dashboard/GatehouseForm.vue';

export default {
    components: {
        GatehouseForm,
    },
    data() {
        return {
            gatehouse: {}
        }
    },
    created() {
        this.getGatehouse();
    },
    methods: {
        getGatehouse() {
            this.$store.getters.api.get(`/dashboard/${this.$route.params.slug}/gatehouse`)
            .then(response => {
                this.gatehouse = response.data;
            })
            .catch(error => {
                console.error("Error loading gatehouse. ", error)
            });
        },
        submitForm() {
            if (this.$refs.gatehouseForm?.submitForm) {
                this.$refs.gatehouseForm.submitForm();
            }
        },
        editGatehouse(data) {
            const formData = {
                name: data.name,
                address: data.address
            }

            this.$store.getters.api.patch(`/dashboard/${this.$route.params.slug}/gatehouse/${this.$route.params.id}/edit`, formData)
            .then(() => {
                this.$router.replace({
                    name: "GatehouseView",
                    params: {
                        slug: this.$route.params.slug
                    }
                })
            })
            .catch(error => {
                console.error("Error updating gatehouse.", error);
            });
        }
    }
}
</script>